module.exports = __webpack_public_path__ + "static/media/arrow-down.89a6e5ac.svg";